/**
 * Service for handling URL paths and path-related utilities
 */

/**
 * Parse URL path segments from a pathname
 */
export const parsePathSegments = (pathname: string) => {
  const segments = pathname.split('/').filter(Boolean);
  return {
    firstSegment: segments[0] || '',
    secondSegment: segments[1] || '',
    segments
  };
};

/**
 * Check if a path contains consecutive slashes that need fixing
 */
export const pathNeedsFixing = (pathname: string): boolean => {
  return pathname.includes('//');
};

/**
 * Fix a path by removing consecutive slashes
 */
export const fixPath = (pathname: string): string => {
  return pathname.replace(/\/{2,}/g, '/');
};

/**
 * Get current path segment at a specific index
 */
export const getPathSegment = (pathname: string, index: number): string => {
  const segments = pathname.split('/').filter(Boolean);
  return segments[index] || '';
};

/**
 * Utility for common path operations
 */
const PathService = {
  parsePathSegments,
  pathNeedsFixing,
  fixPath,
  getPathSegment
};

export default PathService; 